'use client';

import { c as _c } from "react/compiler-runtime";
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import Typography from '@classify/react-core-components/Typography';
import BackLink from '@classify/react-core-components/BackLink';
import { alpha, darken, styled } from '@classify/react-core-components/styles';
import Stack from '@classify/react-core-components/Stack';
import Box from '@classify/react-core-components/Box';
import { getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
import HeroAction from './HeroAction';
import HeroAside from './HeroAside';
import useCourseStatus from '../../_hooks/useCourseStatus';
import CourseMetadata from './CourseMetadata';
import { useCourseContext } from '../../_contexts/CourseContext';
type Props = {
  userId?: number;
};
const Wrapper = styled('div')(({
  theme
}) => ({
  padding: theme.spacing(3, 3, 5, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 4, 7, 4)
  },
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(4, 7, 11, 7)
  }
}));
const Content = styled('div')(({
  theme
}) => ({
  maxWidth: 768,
  flex: 1,
  marginTop: theme.spacing(4),
  '& > * + *': {
    marginTop: theme.spacing(2)
  },
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(3),
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  [theme.breakpoints.up('lg')]: {
    marginRight: theme.spacing(4)
  }
}));
export default function Hero(t0) {
  const $ = _c(40);
  const {
    userId
  } = t0;
  const {
    course
  } = useCourseContext();
  const status = useCourseStatus(course);
  const {
    title,
    categoryColor,
    category,
    userCourseCompletionRate: progression,
    shortDescription
  } = course;
  const hasCourseStarted = progression && progression > 0;
  let t1;
  if ($[0] !== categoryColor) {
    t1 = alpha(categoryColor, 0.08);
    $[0] = categoryColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const backgroundColor = t1;
  let t2;
  if ($[2] !== categoryColor) {
    t2 = darken(categoryColor, 0.05);
    $[2] = categoryColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const accessibleTitleColor = t2;
  let t3;
  if ($[4] !== backgroundColor) {
    t3 = {
      backgroundColor
    };
    $[4] = backgroundColor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <BackLink {...getButtonLinkProps(ROUTES.COURSES.INDEX)}>{translate("course.home.intro.back.button")}</BackLink>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      xs: "column-reverse",
      md: "row"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mt: {
        xs: 5,
        md: 0
      }
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== accessibleTitleColor) {
    t7 = {
      color: accessibleTitleColor,
      textTransform: "uppercase"
    };
    $[9] = accessibleTitleColor;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== category || $[12] !== t7) {
    t8 = <Typography variant="subheadingSmall" component="p" style={t7}>{category}</Typography>;
    $[11] = category;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== title) {
    t9 = <Typography variant="h2" component="h1" id="course-title">{title}</Typography>;
    $[14] = title;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== hasCourseStarted || $[20] !== shortDescription) {
    t11 = shortDescription && !hasCourseStarted && <Typography variant="body">{shortDescription}</Typography>;
    $[19] = hasCourseStarted;
    $[20] = shortDescription;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== course || $[23] !== hasCourseStarted) {
    t12 = !hasCourseStarted && <CourseMetadata course={course} />;
    $[22] = course;
    $[23] = hasCourseStarted;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      mt: 4
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== status || $[27] !== userId) {
    t14 = <Box sx={t13}><HeroAction status={status} userId={userId} /></Box>;
    $[26] = status;
    $[27] = userId;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t14) {
    t15 = <Content>{t10}{t11}{t12}{t14}</Content>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Stack justifyContent="center"><HeroAside /></Stack>;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t15) {
    t17 = <ContentWrapper>{t4}<Stack direction={t5} alignItems="center" sx={t6}>{t15}{t16}</Stack></ContentWrapper>;
    $[35] = t15;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t3) {
    t18 = <Wrapper style={t3} id="course-hero">{t17}</Wrapper>;
    $[37] = t17;
    $[38] = t3;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}